import React, { useEffect, useRef } from "react";
import { MapContainer, TileLayer, Marker, Popup, Polyline, useMap } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

// Fix default marker icon paths (Webpack quirk)
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
  iconUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
  shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
});

const driverIcon = L.divIcon({
  className: "",
  html: `<div style="background:#E32636;color:#fff;width:34px;height:34px;border-radius:50%;display:grid;place-items:center;border:3px solid #fff;box-shadow:0 4px 12px rgba(0,0,0,0.25);font-size:16px;">🛵</div>`,
  iconSize: [34, 34],
  iconAnchor: [17, 17],
});

const clientIcon = L.divIcon({
  className: "",
  html: `<div style="background:#009E60;color:#fff;width:34px;height:34px;border-radius:50%;display:grid;place-items:center;border:3px solid #fff;box-shadow:0 4px 12px rgba(0,0,0,0.25);font-size:16px;">📍</div>`,
  iconSize: [34, 34],
  iconAnchor: [17, 34],
});

function AutoFit({ points }) {
  const map = useMap();
  useEffect(() => {
    if (!points.length) return;
    if (points.length === 1) {
      map.setView(points[0], 15, { animate: true });
    } else {
      const bounds = L.latLngBounds(points);
      map.fitBounds(bounds, { padding: [40, 40], maxZoom: 16 });
    }
  }, [points, map]);
  return null;
}

export default function DeliveryMap({ driverLoc, clientPos, height = 280 }) {
  const center = driverLoc ? [driverLoc.lat, driverLoc.lng] : clientPos || [9.6412, -13.5784]; // Conakry default
  const driverPos = driverLoc ? [driverLoc.lat, driverLoc.lng] : null;
  const polyline = driverPos && clientPos ? [driverPos, clientPos] : null;
  const fitPoints = [driverPos, clientPos].filter(Boolean);

  return (
    <div style={{ height, width: "100%", borderRadius: "1rem", overflow: "hidden" }} data-testid="delivery-map">
      <MapContainer center={center} zoom={14} style={{ height: "100%", width: "100%" }} scrollWheelZoom={false}>
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a>'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        {driverPos && (
          <Marker position={driverPos} icon={driverIcon}>
            <Popup>{driverLoc?.driver_name || "Livreur"} en route</Popup>
          </Marker>
        )}
        {clientPos && (
          <Marker position={clientPos} icon={clientIcon}>
            <Popup>Point de livraison</Popup>
          </Marker>
        )}
        {polyline && <Polyline positions={polyline} pathOptions={{ color: "#E32636", weight: 4, dashArray: "8, 8" }} />}
        <AutoFit points={fitPoints} />
      </MapContainer>
    </div>
  );
}
